 
<div class="row" *ngIf="listsLoaded==false">

  <div class="col-sm-12">
    One moment please...
  </div>

</div>

<div class="row " *ngIf="listsLoaded==true">

  <div class="col-sm-12 searchControls">
    
    <div class='gridCell'> 
      <div> 
          <label for="">Lectionary Source</label>
          <select [(ngModel)]="model.LectionarySource"   >
            <option></option>
            <option *ngFor="let section of lectionarySources" [ngValue]="section.Id">
              {{section.Name}} ({{section.NameAbbreviated}})
            </option>
          </select> 
      </div>
    </div>

    <div class='gridCell'>
        <div> 
          
            <label for="">Lectionary Item Type</label>
            <select  [(ngModel)]="model.LectionaryItemType"  >
              <option></option>
              <option *ngFor="let section of lectionaryItemTypes" [ngValue]="section.Id">
                {{section.Localized[0].Name}}
              </option>
            </select> 
        </div>
    </div>
 

    <div class='gridCell'>
        <label for="">Lectionary Item Name</label>
        <div><input type="text" [(ngModel)]="model.LectionaryItemName"/></div>
      </div> 

      <div class='gridCell'>
          <label for="">Words in HTML</label>
          <div><input type="text" [(ngModel)]="model.Html"/></div>
        </div> 

        <div class='gridCell' style="align-self:end">
            <button (click)="search()">Search</button>
        </div> 
 
  </div>
 

</div>
